import { GenericError } from '@cian/peperrors/shared';

type TRedirectCode = 301 | 302;

interface IRedirectErrorConfig {
  domain: string;
  message: string;
  location: string;
  code: TRedirectCode;
}

export class RedirectError extends GenericError {
  public location: string;
  public code: TRedirectCode;

  public constructor({ domain, message, location, code }: IRedirectErrorConfig) {
    super({
      domain,
      message,
      type: 'RedirectError',
    });

    this.location = location;
    this.code = code;

    Object.setPrototypeOf(this, RedirectError.prototype);
  }
}
